import { string, object, array } from "yup"

export const IllustrationMappingsFormSchema = object({
  OriginalValue: string()
    .max(100, "Maximum Length Should be 100")
    .label("Original Value")
    .required("Original Value is required field"),
  MappedValue: array()
    .min(1, "Minimum Length Should be 1")
    .max(2, "Maximum Length Should be 2")
    .label("Mapped Value")
    .required("Mapped Value is required field"),
})
